import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

interface LoadingProps {
  message?: string;
  size?: number;
}

const Loading: React.FC<LoadingProps> = ({ 
  message = "Yükleniyor...", 
  size = 60 
}) => {
  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          gap: 2,
        }}
      >
        <CircularProgress 
          size={size} 
          thickness={4}
          sx={{
            color: 'primary.main',
          }}
        />
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            fontWeight: 'medium',
            textAlign: 'center'
          }}
        >
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

export default Loading;
